/**
 * Peer connection factory.
 */
export default function usePeerConnection(configuration: RTCConfiguration): RTCPeerConnection {
	const peerConnection = new RTCPeerConnection(configuration);

	return peerConnection;
}
